'use client'

import { useRouter } from 'next/navigation'
import { ComponentType, SVGProps } from 'react'

import {
  HighRentalIncome,
  FastVacancyResolution,
  ConvenientManagement,
  SafeRental,
} from '@/shared/asset'
import { SignUpIntro } from '@/widgets/sign-up'

const content: {
  title: string
  description: string
  image: ComponentType<SVGProps<SVGSVGElement>>
}[] = [
  {
    title: '높은 임대 수익',
    description:
      '월세 대비 높은 임대료를 받을 수 있고,\n낮은 수수료로 이용이 가능합니다.',
    image: HighRentalIncome,
  },
  {
    title: '빠른 공실 해결',
    description:
      '계약 체결까지 평균 3일이 소요되어\n공실을 빠르게 해결할 수 있습니다.',
    image: FastVacancyResolution,
  },
  {
    title: '편리한 관리',
    description:
      '방 등록부터 계약, 정산까지\n온라인으로 편리하게 관리할 수 있습니다.',
    image: ConvenientManagement,
  },
  {
    title: '안전한 임대',
    description:
      '삼삼엠투 임대인의 예기치 못한 피해를\n삼삼케어로 보상해 드립니다.',
    image: SafeRental,
  },
]

export const SignUpHostIntro = () => {
  const router = useRouter()

  const handleButtonClick = () => {
    router.push('/sign-up/host?step=terms')
  }

  return (
    <SignUpIntro
      title="단기임대를 시작해 보세요"
      content={content}
      buttonText="호스트로 회원가입"
      onButtonClick={handleButtonClick}
    />
  )
}
